import { RetryLink } from '@apollo/client/link/retry';
import { dispatchNetworkError } from './clientEvents';

const MAX_RETRIES_COUNT = 5;

export const retryLink = new RetryLink({
  attempts: (count, operation, error) => {
    // eslint-disable-next-line no-console
    console.error(`Caught error in retryLink for operation ${operation.operationName}`);
    if (count > MAX_RETRIES_COUNT) {
      // eslint-disable-next-line no-console
      console.error(`Maximum number of retries (${MAX_RETRIES_COUNT}) exceeded`);
      // Background operations (context `silent`) handle their own failures without the global error flash.
      if (!operation.getContext().silent) {
        dispatchNetworkError(error || `Retries exceeded for operation ${operation.operationName}`);
      }
      return false;
    }
    return operation.getContext().retry === true;
  },
  delay: (count, operation, _error) => {
    const wait = Math.pow(count, 2) * 500 * Math.random(); // exponential backoff
    // eslint-disable-next-line no-console
    console.log(`Will wait ${wait}ms before retrying operation ${operation.operationName}`);
    return wait;
  },
});
